// The header that is required to return json in camel case from Rma API
export const RMA_JSON_CAMELCASE_HEADER = 'rma.json';
